import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { provideKeycloakAngular } from '@core/init/keycloak-init.factory';
import { httpInterceptorProviders } from '@core/interceptors';
import { ENVIRONMENT_TOKEN, Environment } from '@core/models/environment.model';
import { AuthService } from '@core/services/auth/auth.service';
import { LaunchDarklyService } from '@core/services/launchdarkly/launchdarkly.service';

@NgModule({
  imports: [CommonModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  public static forRoot(environment: Environment): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: ENVIRONMENT_TOKEN, useValue: environment },
        AuthService,
        httpInterceptorProviders,
        LaunchDarklyService,
        provideKeycloakAngular(environment)
      ]
    };
  }
}
